__turbopack_context__.v({
  "description": "CheckoutDescription-module-scss-module__XyGica__description",
  "title": "CheckoutDescription-module-scss-module__XyGica__title",
  "titleGroup": "CheckoutDescription-module-scss-module__XyGica__titleGroup",
  "wrapper": "CheckoutDescription-module-scss-module__XyGica__wrapper",
});
